import { render } from "./ZhengzhouApportion.vue?vue&type=template&id=1228f9ec&scoped=true"
import script from "./ZhengzhouApportion.vue?vue&type=script&lang=js"
export * from "./ZhengzhouApportion.vue?vue&type=script&lang=js"

import "./ZhengzhouApportion.vue?vue&type=style&index=0&id=1228f9ec&scoped=true&lang=css"

import exportComponent from "C:\\ProgramData\\Jenkins\\.jenkins\\workspace\\四个火体育_web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1228f9ec"]])

export default __exports__